export default __webpack_public_path__ + "static/media/8.b9595adc.jpg";